const getCurrentDepartments = (departments, soldToList) =>
  soldToList
    ? departments
        .filter(dept => soldToList.includes(dept.customerNumber))
        .reduce((total, soldTo) => [...total, ...soldTo.customerDepartments], [])
    : null;

export const mapDepartmentName = (list, departments, soldToNumberList = null) => {
  const currDepartments = getCurrentDepartments(departments, soldToNumberList);

  return list.map(order => {
    let dept;
    const { accountNumber, departmentNumber, compDepartmentNumber, billableDepartmentNumber, department } = order;
    const codeChecks = [departmentNumber, compDepartmentNumber, billableDepartmentNumber, department];

    for (let i = 0, l = codeChecks.length; i < l; i++) {
      dept = (soldToNumberList && currDepartments
        ? currDepartments
        : // Attempt scoping to order
          getCurrentDepartments(
            departments,
            departments.length > 0 ? [accountNumber, departments[0].customerNumber] : [accountNumber]
          )
      ).filter(({ customerDepartmentCode }) => customerDepartmentCode === codeChecks[i]);

      // Return first match
      if (dept[0]) return { ...order, departmentName: dept[0].customerDepartmentName };
    }
    return order;
  });
};

export const mapDepartmentNumbers = (deptNames, list) =>
  list.reduce((total, dept) => {
    if (deptNames.includes(dept.customerDepartmentName)) {
      return [...total, dept.customerDepartmentCode];
    }
    if (deptNames.includes(dept.departmentName)) {
      return [...total, dept.department];
    }
    return total;
  }, []);

export const updateAllFilters = (addFilter, removeFilter, filterOptions, key, add) => {
  const { values } = filterOptions.filter(item => item.key === key)[0];

  for (let i = 0, l = values.length; i < l; i++) {
    if (add) addFilter({ key: key, value: values[i] });
    else removeFilter({ key: key, value: values[i] });
  }
};
